<template>
  <div class="home">
    <bg-video v-show="videoVisiable" ref="bv" filename="Home" canskip @playing="played = true" @ended="handleEnded"/>
    <div v-show="!videoVisiable" class="bg-wrap">
      <img v-for="i in 5" :key="i" :src="require(`./img/bg/bg-${i - 1}.jpg`)" class="bg" :class="{bgCurrent: i - 1 === bgIndex}" alt="">
    </div>
    <div v-show="videoVisiable && !played" class="pos-c tips" @click="$refs.bv.play()"/>
    <template v-if="!videoVisiable">
      <div class="logo-wrap">
        <div class="logo" alt="logo"/>
      </div>
      <div v-show="btnVisiable" class="btn-wrap">
        <img class="btn" src="./img/btn.png" alt="点击进入" @click="$router.push('/Start')">
      </div>
      <p class="footer">
        <span>指导单位：中共广东省委宣传部 中共广东省委网信办</span>
        <span>建设单位：南方新闻网</span>
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      videoVisiable: !this.$route.meta.skip,
      played: false,
      bgIndex: 0,
      isCurrent: false,
      btnVisiable: false,
    }
  },
  mounted () {
    if (!this.videoVisiable) {
      this.handleEnded()
    }
  },
  beforeDestroy () {
    clearInterval(this.timter)
  },
  methods: {
    handleEnded () {
      this.videoVisiable = false
      this.btnVisiable = true

      this.timter = setInterval(() => {
        this.bgIndex = (this.bgIndex + 1) % 5
      }, 5000)
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes searchLights {
  0% { left: 0%; top: -50%; }
  to { left: 120%; top: -20%; }
}
@keyframes scale {
  0% { transform: scale(1) }
  to { transform: scale(1.2) }
}

.home {
  width: 19.2rem;
  height: 10.8rem;
  overflow: hidden;
  background-image: url(./img/bg/bg-0.jpg);
  background-size: contain;
  .bg {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 19.2rem;
    height: 10.8rem;
    &.bgCurrent {
      display: block;
      animation: scale 5s ease-in 0s forwards;
    }
  }
  .logo-wrap {
    position: absolute;
    top: 1.55rem;
    right: 0;
    left: 0;
    text-align: center;
    height: 3.9rem;
    .logo {
      display: block;
      position: relative;
      width: 9.8rem;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      background: url(./img/logo.png) center no-repeat;
      background-size: contain;
      // transition: all 2s;
      // transform: scale(0);
    }
    &.current {
      .logo {
        transform: scale(1);
        &:before {
          content: "";
          position: absolute;
          left: -6.6rem;
          top: -50%;
          width: 10%;
          height: 200%;
          background-image: -moz-linear-gradient(0deg, rgba(255,255,255,0), rgba(255,255,255,0.3), rgba(255,255,255,0));
          background-image: -webkit-linear-gradient(0deg, rgba(255,255,255,0), rgba(255,255,255,0.3), rgba(255,255,255,0));
          transform: rotate(30deg);
          animation: searchLights .8s ease-in 2.5s forwards;
        }
      }
    }
  }
  .tips {
    display: inline-block;
    width: 2.4rem;
    height: 1.5rem;
    background-image: url(../../assets/img/icon/pause-text.png);
    background-size: cover;
  }
  .footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0.2rem;
    font-size: 0.2rem;
    text-align: center;
    color: #eee;
    background-color: #002e6a;
    opacity: 0.8;
    span {
      display: inline-block;
      margin: 0 0.15rem;
    }
  }
  .btn-wrap {
    position: absolute;
    top: 6.9rem;
    left: 0;
    width: 19.2rem;
    height: 1rem;
    text-align: center;
    .btn {
      display: inline-block;
      height: 1.22rem;
      margin: 0 0.8rem;
      text-indent: -99999px;
      cursor: pointer;
    }
  }
}
</style>
